(ns ui.components.radix-ui.popover.view
  (:require
   ["@radix-ui/react-popover" :as Popover]
   [clojure.string :as string]
   [reagent.core :as r]
   [ui.util :as uu]))

(defn adapt
  ([cls-name]
   (r/adapt-react-class (aget Popover cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (aget (aget Popover parent-cls) cls-name))))

(def popover-root (adapt "Root"))
(def popover-trigger (adapt "Trigger"))
(def popover-anchor (adapt "Anchor"))
(def popover-portal (adapt "Portal"))
(def popover-content (adapt "Content"))
(def popover-close (adapt "Close"))
(def popover-arrow (adapt "Arrow"))

(def popover-primitive-root (adapt "Root"))
(def popover-primitive-trigger (adapt "Trigger"))
(def popover-primitive-anchor (adapt "Anchor"))
(def popover-primitive-portal (adapt "Portal"))
(def popover-primitive-content (adapt "Content"))
(def popover-primitive-close (adapt "Close"))
(def popover-primitive-arrow (adapt "Arrow"))

(defn- tw2-content-class?
  [content-class]
  (string/includes? (str (or content-class "")) "tw2"))

(defn view
  [{:keys [dom-id open? modal? gray-out-background? on-open-change z-index as-child?
           direction _custom-color on-open-auto-focus _align
           content-class] :as _props}
   trigger-component
   body-component]
  (let [tw2-content? (tw2-content-class? content-class)]
    [:div
     [popover-root
      {:open         open?
       :modal        modal?
       :id           dom-id
       :onOpenChange on-open-change}
      [popover-trigger
       {:asChild (if (boolean? as-child?)
                   as-child?
                   true)}
       [:div trigger-component]]
      [popover-portal
       {:style {:z-index (str (or z-index "20000") " !important")}}
       [:div
        {:style
         (when gray-out-background?
           {:position "fixed"
            :z-index (or z-index "20000")
            :inset 0
            :background "rgb(0,0,0,0.4)"})}
        [popover-content
         (merge
          {:class (uu/cm "relative z-[30000000] duration-300 will-change-transform"
                         (when-not tw2-content?
                           "rounded-md p-3 bg-base-light border border-solid border-base-light-border-paler shadow")
                         content-class)
           :align      "start"
           :sideOffset 5
           :onOpenAutoFocus on-open-auto-focus}
          (when direction
            (case direction
              :top {:side "top"}
              :left {:side "left"}
              :bottom {:side "bottom"}
              :right {:side "right"}
              :top-left {:side  "top"
                         :align "end"}
              :top-right {:side  "top"
                          :align "start"}
              :bottom-left {:side  "bottom"
                            :align "end"}
              :bottom-right {:side  "bottom"
                             :align "start"}
              {}))
          (when z-index
            {:style {:z-index (str z-index " !important")}}))
         body-component]]]]]))
